import { deepAssign, deepExtract } from 'helpers/deep';
import { HEADER_LAYOUT, RESULTS_LAYOUT } from '../Search.constants';
import { SearchVenue } from './SearchVenue';

export class SearchLayout {
  constructor(data = {}, config = {}) {
    const modeledData = { ...data };
    let venuePaths = [];
    if (config.layoutName === RESULTS_LAYOUT) {
      venuePaths = ['web_search_results_01.data.map_items', 'web_search_results_01.data.venue_tab_items'];
    } else if (config.layoutName === HEADER_LAYOUT) {
      venuePaths = ['nearby_venues.data'];
    }

    // Model venue paths
    venuePaths.forEach(path => {
      const value = deepExtract(path, modeledData, []).map(
        venue => new SearchVenue(venue, { distanceUnit: config.distanceUnit })
      );
      if (value.length) {
        deepAssign(path, modeledData, value);
      }
    });

    Object.assign(this, modeledData);
  }
}
